<div class="container">
    <div class="row">
        <div class="col-lg-12">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                    <li class="breadcrumb-item"><a [routerLink]="['/Maintenance']">Mantenimiento</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">{{entityName}}</li>
                </ol>
            </nav>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-5">
            <h4>{{entityName}}</h4>
            <p>{{entityDescription}}</p>
        </div>
        <div class="col-lg-7">
            <p-toolbar>
                <div class="ui-toolbar-group-left">
                    <p-autoComplete [(ngModel)]="selectedId" [disabled]="buttonDisabled" [suggestions]="filteredData"
                        [forceSelection]="true" [dropdown]="true" [minLength]="1" (completeMethod)="onFilter($event)"
                        (onSelect)="onSelect($event)" field="Name" placeholder="Buscar.."></p-autoComplete>
                </div>
                <div class="ui-toolbar-group-right d-md-none  d-lg-none d-xl-none actionButtons">
                    <button pButton type="button" [disabled]="buttonDisabled" (click)="onAddNew();" icon="pi pi-plus"
                        class="toolButtonMin"></button>
                    <button pButton type="button" [disabled]="buttonDisabled" (click)="onEdit();" icon="pi pi-pencil"
                        class="p-button-success toolButtonMin"></button>
                    <button pButton type="button" [disabled]="buttonDisabled" (click)="onDelete();" icon="pi pi-times"
                        class="p-button-danger toolButtonMin"></button>
                </div>
                <div class="ui-toolbar-group-right d-none d-sm-none  d-md-block d-lg-block actionButtons">
                    <button pButton type="button" label="Nuevo" [disabled]="buttonDisabled" (click)="onAddNew();"
                        icon="pi pi-plus" class="toolButton"></button>
                    <button pButton type="button" label="Editar" [disabled]="buttonDisabled" (click)="onEdit();"
                        icon="pi pi-pencil" class="p-button-success toolButton"></button>
                    <button pButton type="button" label="Eliminar" [disabled]="buttonDisabled" (click)="onDelete();"
                        icon="pi pi-times" class="p-button-danger toolButton"></button>
                </div>
            </p-toolbar>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <a [attr.disabled]="buttonDisabled" class="searchLink" (click)="onShowDialog();">Ver todos <i
                    class="fa fa-search"></i></a>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <form [formGroup]="masterForm" class="formClass boxed" (ngSubmit)="onSubmit();">
                <input type="hidden" name="id" formControlName="id">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label for="personTypeId" class="required">Tipo de Identificaci&oacute;n:</label>
                            <select placeholder="Seleccione el tipo de identificaci&oacute;n"
                                formControlName="personTypeId" class="form-control"
                                [ngClass]="{'is-invalid': submitted && masterControls['personTypeId'].errors }">
                                <option *ngFor="let personType of personTypes" [value]="personType.id">
                                    {{personType.name}}
                                </option>
                            </select>
                            <div *ngIf="submitted && masterControls['personTypeId'].errors" class="invalid-feedback">
                                <div *ngIf="masterControls['personTypeId'].errors['required']">El tipo de
                                    identificaci&oacute;n
                                    es requerido.
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="identification" class="required">Identificaci&oacute;n:</label>
                            <input type="text" class="form-control" formControlName="identification"
                                placeholder="Ingrese el numero de identificaci&oacute;n"
                                [ngClass]="{'is-invalid': submitted && masterControls['identification'].errors }">
                            <div *ngIf="submitted && masterControls['identification'].errors" class="invalid-feedback">
                                <div *ngIf="masterControls['identification'].errors['required']">El n&uacute;mero de
                                    identificaci&oacute;n es
                                    requerido.</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="name" class="required">Nombre:</label>
                            <input type="text" class="form-control" formControlName="name"
                                placeholder="Nombre del cliente"
                                [ngClass]="{'is-invalid': submitted && masterControls['name'].errors }">
                            <div *ngIf="submitted && masterControls['name'].errors" class="invalid-feedback">
                                <div *ngIf="masterControls['name'].errors['required']">El nombre es requerido.</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="lastName" class="required">Apellido:</label>
                            <input type="text" class="form-control" formControlName="lastName"
                                placeholder="Ingrese el apellido"
                                [ngClass]="{'is-invalid': submitted && masterControls['lastName'].errors }">
                        </div>
                        <div class="form-group">
                            <label for="email" class="required">Correo electr&oacute;nico:</label>
                            <input type="text" class="form-control" formControlName="email"
                                placeholder="Correo del cliente"
                                [ngClass]="{'is-invalid': submitted && masterControls['email'].errors }">
                            <div *ngIf="submitted && masterControls['email'].errors" class="invalid-feedback">
                                <div *ngIf="masterControls['email'].errors['required']">El correo es requerido.</div>
                                <div *ngIf="masterControls['email'].errors['email']">Formato de correo inv&aacute;lido.
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="phoneNumber1" class="required">Tel&eacute;fono principal:</label>
                            <input type="text" class="form-control" formControlName="phoneNumber1"
                                mask="(000) 0000-0000" placeholder="Tel&eacute;fono principal"
                                [ngClass]="{'is-invalid': submitted && masterControls['phoneNumber1'].errors }">
                        </div>
                        <div class="form-group">
                            <label for="phoneNumber2" class="required">Tel&eacute;fono secundario: (opcional)</label>
                            <input type="text" class="form-control" formControlName="phoneNumber2"
                                mask="(000) 0000-0000" placeholder="Tel&eacute;fono secundario">
                        </div>
                        <div class="form-group">
                            <label for="countryId" class="required">Pa&iacute;s:</label>
                            <select placeholder="Seleccione el pa&iacute;s" formControlName="countryId"
                                class="form-control" (change)="onSelectCountry($any($event.target).value)"
                                [ngClass]="{'is-invalid': submitted && masterControls['countryId'].errors }">
                                <option *ngFor="let country of countries" [value]="country.Id">{{country.Name}}</option>
                            </select>
                            <div *ngIf="submitted && masterControls['countryId'].errors" class="invalid-feedback">
                                <div *ngIf="masterControls['countryId'].errors['required']">El pa&iacute;s es requerido.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <label for="stateId" class="required">Provincia:</label>
                            <select placeholder="Seleccione la provincia" formControlName="stateId" class="form-control"
                                (change)="onSelectState($any($event.target).value)"
                                [ngClass]="{'is-invalid': submitted && masterControls['stateId'].errors }">
                                <option *ngFor="let state of states" [value]="state.Id">{{state.Name}}</option>
                            </select>
                            <div *ngIf="submitted && masterControls['stateId'].errors" class="invalid-feedback">
                                <div *ngIf="masterControls['stateId'].errors['required']">La provincia es requerida.
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="cityId" class="required">Cant&oacute;n:</label>
                            <select placeholder="Seleccione el cant&oacute;n" formControlName="cityId"
                                class="form-control" (change)="onSelectCity($any($event.target).value)"
                                [ngClass]="{'is-invalid': submitted && masterControls['cityId'].errors }">
                                <option *ngFor="let city of cities" [value]="city.Id">{{city.Name}}</option>
                            </select>
                            <div *ngIf="submitted && masterControls['cityId'].errors" class="invalid-feedback">
                                <div *ngIf="masterControls['cityId'].errors['required']">El cant&oacute;n es requerido.
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="districtId" class="required">Distrito:</label>
                            <select placeholder="Seleccione el distrito" formControlName="districtId"
                                class="form-control" (change)="onSelectDistrict($any($event.target).value)"
                                [ngClass]="{'is-invalid': submitted && masterControls['districtId'].errors }">
                                <option *ngFor="let district of districts" [value]="district.Id">{{district.Name}}
                                </option>
                            </select>
                            <div *ngIf="submitted && masterControls['districtId'].errors" class="invalid-feedback">
                                <div *ngIf="masterControls['districtId'].errors['required']"> El distrito es requerido.
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="neighborhoodId" class="required">Barrio:</label>
                            <select placeholder="Seleccione el barrio" formControlName="neighborhoodId"
                                class="form-control"
                                [ngClass]="{'is-invalid': submitted && masterControls['neighborhoodId'].errors }">
                                <option *ngFor="let neighborhood of nighboorhoods" [ngValue]="neighborhood.Id">
                                    {{neighborhood.Name}}</option>
                            </select>
                            <div *ngIf="submitted && masterControls['neighborhoodId'].errors" class="invalid-feedback">
                                <div *ngIf="masterControls['neighborhoodId'].errors['required']"> El barrio es
                                    requerido.
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="address">Direcci&oacute;n:</label>
                            <textarea class="form-control" formControlName="address" rows="3"
                                placeholder="Ingrese la direcci&oacute;n"
                                [ngClass]="{'is-invalid': submitted && masterControls['address'].errors }"></textarea>
                            <div *ngIf="submitted && masterControls['address'].errors" class="invalid-feedback">
                                <div *ngIf="masterControls['address'].errors['required']">La direcci&oacute;n es
                                    requerida.
                                </div>
                            </div>
                        </div>
                        <div class=" form-group">
                            <label for="Detail">Detalle:</label>
                            <textarea formControlName="detail" class="form-control" rows="3"
                                placeholder="Ingrese una descripcion"></textarea>
                        </div>
                        <div class="input-group">
                            <div class="form-group">
                                <label for="isActive">
                                    <input type="checkbox" formControlName="isActive" class="checkbox"> Activo:
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <button type="submit" class="btn btn-primary btn-block"
                            [disabled]="!buttonDisabled">Guardar</button>
                        <button type="button" class="btn btn-secondary btn-block" [disabled]="!buttonDisabled"
                            (click)="onCancel();">Cancelar</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<p-dialog header="{{entityName}}" [(visible)]="showDialog" [modal]="true" [responsive]="true"
    [style]="{width: '80%', minWidth: '80%'}" [minY]="70" [maximizable]="true" [baseZIndex]="10000">
    <p-table [columns]="cols" [value]="data" [paginator]="true" [rows]="5">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    {{rowData[col.field]}}
                </td>
                <td class="text-center">
                    <a [attr.disabled]="buttonDisabled" (click)="selectedId=rowData['Id']; onSelectFromGrid();"><span
                            class="fa fa-eye searchIcon"></span></a>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <p-footer>
        <button type="button" pButton icon="pi pi-close" (click)="showDialog=false" label="Cerrar"></button>
    </p-footer>
</p-dialog>
<p-toast [style]="{marginTop: '100px'}" position="top-center" key="tc" [hideTransitionOptions]="'1ms'">
</p-toast>
<synergy-spinner [show]="loading"></synergy-spinner>
<p-confirmDialog #cd header="Confirmacion" icon="pi pi-exclamation-triangle">
    <p-footer>
        <div class="row">
            <div class="col-6">
                <button type="button" class="btn btn-danger fixedButton" label="Cancelar"
                    (click)="cd.accept()">Eliminar</button>
            </div>
            <div class="col-6">
                <button type="button" class="btn btn-secondary fixedButton" label="Salir"
                    (click)="cd.reject()">Cancelar</button>
            </div>
        </div>
    </p-footer>
</p-confirmDialog>